module.exports = __webpack_public_path__ + "img/baby3.41844e67.jpg";